import { apiRequest, clearGetCache } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

function invalidateChapterQuestions(chapterId) {
  if (chapterId != null) {
    clearGetCache(`/api/chapters/${chapterId}/questions`);
  }
}

function invalidateQuestion(questionId) {
  if (questionId != null) {
    clearGetCache(`/api/questions/${questionId}`);
    clearGetCache(`/api/questions/${questionId}/answers`);
  }
}

export async function getChapterQuestions(chapterId) {
  return apiRequest(`/api/chapters/${chapterId}/questions`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function createChapterQuestion(chapterId, content) {
  const response = await apiRequest(`/api/chapters/${chapterId}/questions`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ content }),
  });
  invalidateChapterQuestions(chapterId);
  return response;
}

export async function getQuestionById(questionId) {
  return apiRequest(`/api/questions/${questionId}`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function updateQuestion(questionId, content) {
  const response = await apiRequest(`/api/questions/${questionId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ content }),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function deleteQuestion(questionId) {
  const response = await apiRequest(`/api/questions/${questionId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function pinQuestion(questionId) {
  const response = await apiRequest(`/api/questions/${questionId}/pin`, {
    method: 'PUT',
    headers: getAuthHeaders(),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function unpinQuestion(questionId) {
  const response = await apiRequest(`/api/questions/${questionId}/pin`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function reportQuestion(questionId, { title, description }) {
  return apiRequest(`/api/questions/${questionId}/report`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ title, description }),
  });
}

export async function likeQuestion(questionId) {
  const response = await apiRequest(`/api/questions/${questionId}/like`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function dislikeQuestion(questionId) {
  const response = await apiRequest(`/api/questions/${questionId}/dislike`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function getQuestionAnswers(questionId) {
  return apiRequest(`/api/questions/${questionId}/answers`, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function createQuestionAnswer(questionId, content) {
  const response = await apiRequest(`/api/questions/${questionId}/answers`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ content }),
  });
  invalidateQuestion(questionId);
  return response;
}

export async function updateAnswer(answerId, content) {
  const response = await apiRequest(`/api/answers/${answerId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ content }),
  });
  return response;
}

export async function deleteAnswer(answerId) {
  const response = await apiRequest(`/api/answers/${answerId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  return response;
}

export async function likeAnswer(answerId) {
  return apiRequest(`/api/answers/${answerId}/like`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
}

export async function dislikeAnswer(answerId) {
  return apiRequest(`/api/answers/${answerId}/dislike`, {
    method: 'POST',
    headers: getAuthHeaders(),
  });
}
